import React, { useState, useEffect, useMemo, useId } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO = `${API}/prospects/logo.png`;
const WHATSAPP_INSTITUCIONAL = "5511974795016";

// ============ DOMÍNIO ============
const SERIES_GROUPS = [
  { group: "Educação Infantil", items: ["Jardim I", "Jardim II"] },
  { group: "Ensino Fundamental I", items: ["1º Ano", "2º Ano", "3º Ano", "4º Ano", "5º Ano"] },
  { group: "Ensino Fundamental II", items: ["6º Ano", "7º Ano", "8º Ano", "9º Ano"] },
  { group: "Ensino Médio", items: ["1º Ano do Ensino Médio", "2º Ano do Ensino Médio", "3º Ano do Ensino Médio"] },
];
const STUDENT_PERIODS = ["Manhã", "Tarde", "Integral"];
const HERO_PHOTO = "/novo-dna-aluna-filha.jpg";
// ============ NAV — apenas redes sociais (pedido do usuário) ============
const ORIGENS = [
  { key: "family_referral", label: "Família/aluno da escola" },
  { key: "friend",          label: "Amigo ou conhecido" },
  { key: "instagram",       label: "Instagram" },
  { key: "facebook",        label: "Facebook" },
  { key: "google",          label: "Google" },
  { key: "walk_by",         label: "Passei em frente à escola" },
  { key: "event",           label: "Evento" },
  { key: "staff",           label: "Professor/colaborador" },
  { key: "other",           label: "Outro" },
];

// ============ SVG ICONS (sem emojis) ============
const Ic = {
  Book:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2Z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7Z"/></svg>),
  Laptop:  (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M2 20h20"/></svg>),
  Star:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9Z"/></svg>),
  Globe:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a13 13 0 0 1 0 18M12 3a13 13 0 0 0 0 18"/></svg>),
  Sprout:  (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M7 20h10"/><path d="M12 20V10"/><path d="M12 10c0-4 3-6 7-6-1 4-3 6-7 6Z"/><path d="M12 14c0-3-2-5-5-5 1 3 2 5 5 5Z"/></svg>),
  Users:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1A4 4 0 0 1 16 11"/></svg>),
  House:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M3 10 12 3l9 7v10a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1Z"/></svg>),
  Calendar:(p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>),
  Chat:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M21 12a8 8 0 0 1-11.5 7.2L4 21l1.8-5.5A8 8 0 1 1 21 12Z"/></svg>),
  Compass: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9"/><path d="m15 9-3 3-4 4 4-8 4 4Z"/></svg>),
  Check:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m4 12 5 5L20 6"/></svg>),
  Arrow:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M5 12h14M13 5l7 7-7 7"/></svg>),
  Phone:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M22 16.9v3a2 2 0 0 1-2.2 2 20 20 0 0 1-8.6-3 20 20 0 0 1-6-6A20 20 0 0 1 2 4.1 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.4-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.7.7A2 2 0 0 1 22 16.9Z"/></svg>),
  Mail:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 6 10 8L22 6"/></svg>),
  Pin:     (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0Z"/><circle cx="12" cy="10" r="3"/></svg>),
  Wpp:     (p) => (<svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M12.04 2c-5.5 0-9.96 4.46-9.96 9.96 0 1.76.46 3.48 1.34 5L2 22l5.16-1.35a9.9 9.9 0 0 0 4.88 1.25c5.5 0 9.96-4.46 9.96-9.96S17.54 2 12.04 2Zm4.48 14.02c-.24-.12-1.43-.71-1.65-.79-.22-.08-.38-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.52.06-.24-.12-1.02-.38-1.95-1.19a7.3 7.3 0 0 1-1.35-1.67c-.14-.24-.02-.37.1-.49.11-.11.24-.28.36-.42s.16-.24.24-.4.04-.3-.02-.42c-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.42.06-.64.3-.22.24-.85.83-.85 2.03s.87 2.35.99 2.52c.12.16 1.7 2.6 4.13 3.65.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.43-.58 1.63-1.15.2-.57.2-1.05.14-1.15-.06-.1-.22-.16-.46-.28Z"/></svg>),
  Ig:      (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.6" fill="currentColor"/></svg>),
  Fb:      (p) => (<svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M22 12a10 10 0 1 0-11.6 9.9v-7H8v-2.9h2.4V9.4c0-2.4 1.4-3.7 3.6-3.7 1 0 2.1.2 2.1.2v2.3h-1.2c-1.2 0-1.5.7-1.5 1.5v1.8h2.6l-.4 2.9h-2.2V22A10 10 0 0 0 22 12Z"/></svg>),
  Yt:      (p) => (<svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M23.5 6.5a3 3 0 0 0-2.1-2.1C19.5 4 12 4 12 4s-7.5 0-9.4.4A3 3 0 0 0 .5 6.5C0 8.5 0 12 0 12s0 3.5.5 5.5a3 3 0 0 0 2.1 2.1C4.5 20 12 20 12 20s7.5 0 9.4-.4a3 3 0 0 0 2.1-2.1c.5-2 .5-5.5.5-5.5s0-3.5-.5-5.5ZM9.6 15.6V8.4l6.2 3.6-6.2 3.6Z"/></svg>),
};

// ============ BENEFÍCIOS (grid 3×2) ============
const BENEFITS = [
  { Icon: Ic.Book,    title: "Proposta inovadora",         desc: "Metodologias ativas que colocam o aluno no centro do aprendizado." },
  { Icon: Ic.Star,  title: "Uma das melhores escolas da região",  desc: "Referência em qualidade de ensino e resultados reconhecidos pelas famílias." },
  { Icon: Ic.Globe,   title: "Inglês todos os dias",       desc: "Imersão no idioma desde a Educação Infantil com material próprio." },
  { Icon: Ic.Sprout,  title: "Desenvolvimento integral",   desc: "Projeto pedagógico que une cognição, socioemocional e valores." },
  { Icon: Ic.Users,   title: "Acompanhamento próximo",     desc: "Comunicação transparente e parceria constante com as famílias." },
  { Icon: Ic.House,   title: "Ambiente acolhedor",         desc: "Espaços seguros, modernos e que inspiram descobertas todos os dias." },
];

// ============ FAIXA STATS ============
const STATS = [
  { n: "+20", label: "anos de história" },
  { Icon: Ic.Users, label: "Alunos protagonistas" },
  { Icon: Ic.Sprout, label: "Ensino que transforma" },
  { Icon: Ic.House, label: "Infraestrutura completa" },
  { Icon: Ic.Users, label: "Família e escola lado a lado" },
];

// ============ ESTRUTURA (removido - user request) ============
// Nota: seção Estrutura foi removida a pedido do usuário. Manter constantes vazias
// para compatibilidade com imports/refs (nenhum consumidor ativo).

// ============ DIFERENCIAIS HERO ============
const HERO_DIFFS = [
  { Icon: Ic.Book,   label: "Inglês todos os dias" },
  { Icon: Ic.Star,   label: "Uma das melhores escolas da região" },
  { Icon: Ic.Sprout, label: "Desenvolvimento socioemocional" },
  { Icon: Ic.Users,  label: "Acompanhamento com famílias" },
];

// ============ FORM SIDE BULLETS ============
const FORM_BULLETS = [
  { Icon: Ic.House,    label: "Visite nossa estrutura" },
  { Icon: Ic.Sprout,   label: "Conheça nossa proposta pedagógica" },
  { Icon: Ic.Chat,     label: "Tire suas dúvidas" },
  { Icon: Ic.Compass,  label: "Descubra o melhor para seu filho(a)" },
];

// ============ PROVA SOCIAL (depoimentos) ============
const TESTIMONIALS = [
  { quote: "Vocês realmente fizeram da escola uma importante extensão da nossa casa, com todo o cuidado e aprendizado que eles receberam. Se não estivéssemos mudando de cidade, eles permaneceriam no Colégio até o fim do ensino médio.", author: "Família Miguel e Maria Clara", detail: "Depoimento enviado pela família" },
  { quote: "Eu nem sei como agradecer, o Gael chegou tão tão feliz. O melhor lugar, a melhor escola.", author: "Família Gael e Davi", detail: "Depoimento enviado pela família" },
  { quote: "O Rico passou na ETEC! Só tenho a agradecer a vocês por todo apoio, cuidado e incentivo. Não tenho palavras para externar tamanha gratidão pelo Instituto.", author: "Família Ricardo", detail: "Depoimento enviado pela família" },
];

const MAX_SIBLINGS = 6;
const emptyStudent = () => ({
  key: Math.random().toString(36).slice(2),
  name: "", birth_date: "", interest_series: "", student_period: "",
  current_school: "", wants_integral: null, wants_lunch: null, observation: "",
});

// ============ PÁGINA ============
export default function NovosDNAsPublicLanding() {
  const [form, setForm] = useState({
    responsible_name: "", responsible_phone: "", responsible_email: "",
    interest_year: 2026,
    origin_channel: "", referral_name: "", origin_other: "",
    observation: "", consent: false,
  });
  const [students, setStudents] = useState([emptyStudent()]);
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [serverError, setServerError] = useState("");

  useEffect(() => { document.title = "Novo DNA · Um novo jeito de aprender"; }, []);

  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const mark = (k) => setTouched((t) => ({ ...t, [k]: true }));
  const updStudent = (i, k, v) => setStudents((list) =>
    list.map((s, idx) => (idx === i ? { ...s, [k]: v } : s)));
  const addSibling = () => setStudents((list) =>
    list.length >= MAX_SIBLINGS ? list : [...list, emptyStudent()]);
  const removeSibling = (i) => setStudents((list) => list.filter((_, idx) => idx !== i));

  const studentErrors = useMemo(() => students.map((s) => {
    const e = {};
    if (!s.name.trim()) e.name = "Informe o nome do aluno(a).";
    if (!s.birth_date) e.birth_date = "Informe a data de nascimento do aluno.";
    else {
      const d = new Date(`${s.birth_date}T00:00:00`);
      const year = Number(s.birth_date.slice(0, 4));
      if (Number.isNaN(d.getTime()) || year < 1900) e.birth_date = "Data de nascimento inválida.";
      else if (d > new Date()) e.birth_date = "A data de nascimento não pode ser futura.";
    }
    if (!s.interest_series) e.interest_series = "Selecione a série.";
    if (!s.student_period) e.student_period = "Selecione o período.";
    if (!s.current_school.trim()) e.current_school = "Informe a escola atual do aluno(a).";
    if (s.wants_integral === null) e.wants_integral = "Selecione uma opção.";
    if (s.wants_lunch === null) e.wants_lunch = "Selecione uma opção.";
    return e;
  }), [students]);

  const errors = useMemo(() => {
    const e = {};
    if (!form.responsible_name.trim())            e.responsible_name = "Informe o nome completo.";
    if (!/^[\d\s()+\-.]{10,}$/.test(form.responsible_phone.trim())) e.responsible_phone = "Telefone inválido.";
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.responsible_email.trim())) e.responsible_email = "E-mail inválido.";
    if (!form.origin_channel)                     e.origin_channel = "Selecione uma opção.";
    if ((form.origin_channel === "family_referral" || form.origin_channel === "friend" || form.origin_channel === "staff") && !form.referral_name.trim())
      e.referral_name = "Informe o nome de quem indicou.";
    if (form.origin_channel === "other" && !form.origin_other.trim())
      e.origin_other = "Descreva como conheceu.";
    if (!form.consent)                            e.consent = "É necessário aceitar a política de privacidade.";
    if (!form.observation.trim())                 e.observation = "Conte-nos algo sobre o interesse da família.";
    return e;
  }, [form]);

  const isValid = Object.keys(errors).length === 0
    && studentErrors.every((e) => Object.keys(e).length === 0);

  const submit = async (e) => {
    e.preventDefault();
    const all = {}; Object.keys(form).forEach((k) => { all[k] = true; });
    students.forEach((s, i) => { Object.keys(s).forEach((k) => { all[`s${i}_${k}`] = true; }); });
    setTouched(all);
    setServerError("");
    if (!isValid) return;
    setLoading(true);
    try {
      const payload = {
        responsible_name: form.responsible_name,
        responsible_phone: form.responsible_phone,
        responsible_email: form.responsible_email,
        interest_year: form.interest_year,
        origin_channel: form.origin_channel,
        referral_name: form.referral_name,
        origin_other: form.origin_other,
        observation: form.observation,
        consent: form.consent,
        students: students.map((s) => ({
          name: s.name, birth_date: s.birth_date, interest_series: s.interest_series,
          interest_year: form.interest_year, student_period: s.student_period,
          current_school: s.current_school,
          wants_integral: !!s.wants_integral, wants_lunch: !!s.wants_lunch,
          observation: s.observation || null,
        })),
      };
      const { data } = await axios.post(`${API}/prospects/public`, payload);
      setSuccess({ protocol: data.protocol, duplicated: data.duplicated,
                    first_name: form.responsible_name.trim().split(" ")[0] });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      setServerError(err?.response?.data?.detail || "Não foi possível enviar. Tente novamente.");
    } finally { setLoading(false); }
  };

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }); // eslint-disable-line no-unused-vars

  if (success) return <SuccessScreen success={success} onReset={() => { setSuccess(null); setStudents([emptyStudent()]); setForm({
    responsible_name: "", responsible_phone: "", responsible_email: "",
    interest_year: 2026,
    origin_channel: "", referral_name: "", origin_other: "",
    observation: "", consent: false,
  }); setTouched({}); }} />;

  return (
    <div className="ndn-root">
      <StyleTag />

      {/* NAV */}
      <header className="ndn-nav">
        <div className="ndn-nav-inner">
          <a href="#top" className="ndn-brand" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
            <img src={LOGO} alt="Novo DNA · Instituto de Aprendizagem" />
            <div className="ndn-brand-text">
              <div className="ndn-brand-name">NOVO DNA</div>
              <div className="ndn-brand-sub">INSTITUTO DE APRENDIZAGEM</div>
            </div>
          </a>
          <nav className="ndn-nav-social" aria-label="Nossas redes sociais">
            <a href="https://instagram.com/novodnainstituto" target="_blank" rel="noreferrer" aria-label="Instagram @novodnainstituto" data-testid="nav-social-instagram"><Ic.Ig width={22} height={22} /></a>
            <a href="https://facebook.com/novodnainstituto" target="_blank" rel="noreferrer" aria-label="Facebook @novodnainstituto" data-testid="nav-social-facebook"><Ic.Fb width={22} height={22} /></a>
            <a href="https://youtube.com/@novodnainstituto" target="_blank" rel="noreferrer" aria-label="YouTube @novodnainstituto" data-testid="nav-social-youtube"><Ic.Yt width={22} height={22} /></a>
            <a href={`https://wa.me/${WHATSAPP_INSTITUCIONAL}`} target="_blank" rel="noreferrer" aria-label="WhatsApp" data-testid="nav-social-whatsapp"><Ic.Wpp width={22} height={22} /></a>
            <span className="ndn-nav-handle">@novodnainstituto</span>
          </nav>
        </div>
      </header>

      {/* MAIN GRID: esquerda (hero + form) / direita (benefícios + stats + estrutura + contato) */}
      <main className="ndn-main">
        {/* ============ COLUNA ESQUERDA ============ */}
        <div className="ndn-col-left">
          {/* HERO */}
          <section id="escola" className="ndn-hero">
            <div className="ndn-hero-copy">
              <h1 className="ndn-h1">
                Venha conhecer<br />
                um <span className="ndn-h1-accent">novo jeito</span><br />
                de aprender.
              </h1>
              <p className="ndn-lead">
                Formamos mentes curiosas, criativas e preparadas para o futuro,
                com ética, cuidado e propósito.
              </p>
            </div>
            {/* Área do aluno protagonista — foto + hélice DNA + ambiente escolar */}
            <div className="ndn-hero-visual" aria-hidden>
              <div className="ndn-hero-photo-wrap">
                <img
                  className="ndn-hero-photo"
                  src={HERO_PHOTO}
                  alt=""
                />
              </div>
              <DnaHelix />
            </div>
            {/* Diferenciais em faixa */}
            <div id="diferenciais" className="ndn-hero-diffs">
              {HERO_DIFFS.map(({ Icon, label }) => (
                <div key={label} className="ndn-hero-diff">
                  <div className="ndn-hero-diff-ic"><Icon width={18} height={18} /></div>
                  <div className="ndn-hero-diff-label">{label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* WAVE DIVIDER */}
          <div className="ndn-wave" aria-hidden>
            <svg viewBox="0 0 1200 80" preserveAspectRatio="none">
              <path d="M0 40 C 300 80, 600 0, 900 40 S 1200 60, 1200 40 L 1200 80 L 0 80 Z" fill="#7B3F98" opacity="0.14"/>
              <path d="M0 50 C 300 90, 600 10, 900 50 S 1200 70, 1200 50 L 1200 80 L 0 80 Z" fill="#7B3F98" opacity="0.22"/>
            </svg>
          </div>

          {/* FORMULÁRIO */}
          <section id="agendar" className="ndn-form-block">
            <div className="ndn-form-side">
              <h2 className="ndn-form-side-title">
                Agende uma visita<br />
                e conheça o <span className="ndn-h1-accent">Novo DNA</span>!
              </h2>
              <p className="ndn-form-side-sub">
                Preencha seus dados e nossa equipe entrará em contato para
                confirmar a melhor data.
              </p>
              <ul className="ndn-form-bullets">
                {FORM_BULLETS.map(({ Icon, label }) => (
                  <li key={label}>
                    <span className="ndn-form-bullet-ic"><Icon width={16} height={16} /></span>
                    {label}
                  </li>
                ))}
              </ul>
            </div>

            <div className="ndn-form-card">
              <div className="ndn-form-card-badge">Pré-cadastro</div>
              <form className="ndn-form" onSubmit={submit} noValidate data-testid="novosdna-form">
                {/* Responsável */}
                <div className="ndn-fgroup">Responsável</div>
                <Field label="Nome completo*" error={touched.responsible_name && errors.responsible_name}>
                  <input placeholder="Seu nome completo" value={form.responsible_name}
                    onChange={(e) => upd("responsible_name", e.target.value)} onBlur={() => mark("responsible_name")}
                    data-testid="novosdna-responsible-name" />
                </Field>
                <div className="ndn-grid-2">
                  <Field label="WhatsApp / Telefone*" error={touched.responsible_phone && errors.responsible_phone}>
                    <input inputMode="tel" placeholder="(11) 99999-9999" value={form.responsible_phone}
                      onChange={(e) => upd("responsible_phone", e.target.value)} onBlur={() => mark("responsible_phone")}
                      data-testid="novosdna-responsible-phone" />
                  </Field>
                  <Field label="E-mail*" error={touched.responsible_email && errors.responsible_email}>
                    <input type="email" placeholder="seu@email.com" value={form.responsible_email}
                      onChange={(e) => upd("responsible_email", e.target.value)} onBlur={() => mark("responsible_email")}
                      data-testid="novosdna-responsible-email" />
                  </Field>
                </div>

                {/* Alunos (irmãos no mesmo pré-cadastro) */}
                {students.map((s, i) => {
                  const se = studentErrors[i] || {};
                  const tk = (k) => touched[`s${i}_${k}`];
                  const markS = (k) => setTouched((t) => ({ ...t, [`s${i}_${k}`]: true }));
                  return (
                    <div key={s.key} className="ndn-student-card" data-testid={`novosdna-student-card-${i}`}>
                      <div className="ndn-student-head">
                        <span className="ndn-fgroup">Aluno(a) {i + 1}</span>
                        {i > 0 && (
                          <button type="button" className="ndn-removesib"
                            onClick={() => removeSibling(i)} data-testid={`novosdna-remove-sibling-${i}`}>
                            Remover este aluno
                          </button>
                        )}
                      </div>
                      <div className="ndn-grid-3">
                        <Field label="Nome completo*" error={tk("name") && se.name}>
                          <input placeholder="Nome do aluno(a)" value={s.name}
                            onChange={(e) => updStudent(i, "name", e.target.value)} onBlur={() => markS("name")}
                            data-testid={`novosdna-student-name-${i}`} />
                        </Field>
                        <Field label="Data de nascimento*" error={tk("birth_date") && se.birth_date}>
                          <input type="date" value={s.birth_date}
                            max={new Date().toISOString().slice(0, 10)} min="1900-01-01"
                            onChange={(e) => updStudent(i, "birth_date", e.target.value)}
                            onBlur={() => markS("birth_date")}
                            data-testid={`novosdna-student-birth-date-${i}`} />
                        </Field>
                        <Field label="Série / Ano de interesse*" error={tk("interest_series") && se.interest_series}>
                          <select value={s.interest_series}
                            onChange={(e) => updStudent(i, "interest_series", e.target.value)} onBlur={() => markS("interest_series")}
                            data-testid={`novosdna-interest-series-${i}`}>
                            <option value="">Selecione a série</option>
                            {SERIES_GROUPS.map((g) => (
                              <optgroup key={g.group} label={g.group}>
                                {g.items.map((x) => <option key={x} value={x}>{x}</option>)}
                              </optgroup>
                            ))}
                          </select>
                        </Field>
                        <Field label="Período que prefere*" error={tk("student_period") && se.student_period}>
                          <select value={s.student_period}
                            onChange={(e) => updStudent(i, "student_period", e.target.value)} onBlur={() => markS("student_period")}
                            data-testid={`novosdna-student-period-${i}`}>
                            <option value="">Selecione o período</option>
                            {STUDENT_PERIODS.map((x) => <option key={x} value={x}>{x}</option>)}
                          </select>
                        </Field>
                      </div>
                      <Field label="Qual a escola atual do aluno(a)?*" error={tk("current_school") && se.current_school}>
                        <input placeholder="Digite o nome da escola atual" value={s.current_school}
                          onChange={(e) => updStudent(i, "current_school", e.target.value)} onBlur={() => markS("current_school")}
                          data-testid={`novosdna-current-school-${i}`} />
                      </Field>
                      <div className="ndn-grid-2">
                        <Field label="Deseja período integral?*" error={tk("wants_integral") && se.wants_integral}>
                          <YesNo value={s.wants_integral}
                            onChange={(v) => { updStudent(i, "wants_integral", v); markS("wants_integral"); }}
                            testId={`novosdna-integral-${i}`} />
                        </Field>
                        <Field label="Deseja almoço?*" error={tk("wants_lunch") && se.wants_lunch}>
                          <YesNo value={s.wants_lunch}
                            onChange={(v) => { updStudent(i, "wants_lunch", v); markS("wants_lunch"); }}
                            testId={`novosdna-lunch-${i}`} />
                        </Field>
                      </div>
                      <Field label="Observação sobre esta criança (opcional)">
                        <input placeholder="Ex.: precisa de acompanhamento em leitura" value={s.observation}
                          onChange={(e) => updStudent(i, "observation", e.target.value)}
                          data-testid={`novosdna-student-observation-${i}`} />
                      </Field>
                    </div>
                  );
                })}

                {students.length < MAX_SIBLINGS && (
                  <div className="ndn-addsib-wrap">
                    <button type="button" className="ndn-addsib" onClick={addSibling}
                      data-testid="novosdna-add-sibling">
                      + {students.length === 1 ? "Adicionar irmão(ã)" : "Adicionar outro irmão(ã)"}
                    </button>
                    <p className="ndn-addsib-help">
                      Tem mais de um filho interessado no NOVO DNA? Adicione os dados dos irmãos sem preencher novamente seus dados.
                    </p>
                  </div>
                )}

                {/* Família */}
                <div className="ndn-fgroup">Sobre a família</div>
                <Field label="Quem indicou nossa escola?*" error={touched.origin_channel && errors.origin_channel}>
                  <select value={form.origin_channel}
                    onChange={(e) => { upd("origin_channel", e.target.value); mark("origin_channel"); }}
                    data-testid="novosdna-origin-channel">
                    <option value="">Selecione uma opção</option>
                    {ORIGENS.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
                  </select>
                </Field>
                {(form.origin_channel === "family_referral" || form.origin_channel === "friend" || form.origin_channel === "staff") && (
                  <div className="ndn-reveal">
                    <Field
                      label={
                        form.origin_channel === "staff" ? "Nome do professor ou colaborador*"
                        : form.origin_channel === "friend" ? "Quem indicou o Novo DNA para sua família?*"
                        : "Qual o nome da família ou aluno(a) que indicou o Novo DNA?*"
                      }
                      error={touched.referral_name && errors.referral_name}>
                      <input value={form.referral_name}
                        placeholder={form.origin_channel === "friend" ? "Digite o nome da pessoa" : "Digite o nome de quem indicou"}
                        onChange={(e) => upd("referral_name", e.target.value)} onBlur={() => mark("referral_name")}
                        data-testid="novosdna-referral-name" />
                    </Field>
                  </div>
                )}
                {form.origin_channel === "other" && (
                  <div className="ndn-reveal">
                    <Field label="Como conheceu o Novo DNA?*" error={touched.origin_other && errors.origin_other}>
                      <input value={form.origin_other} placeholder="Conte como chegou até nós"
                        onChange={(e) => upd("origin_other", e.target.value)} onBlur={() => mark("origin_other")}
                        data-testid="novosdna-origin-other" />
                    </Field>
                  </div>
                )}

                {/* Observação obrigatória */}
                <Field label="Conte-nos algo sobre o interesse da família*" error={touched.observation && errors.observation}>
                  <textarea rows={3} placeholder="Ex.: buscamos escola bilíngue com foco em desenvolvimento socioemocional..." value={form.observation}
                    onChange={(e) => upd("observation", e.target.value)} onBlur={() => mark("observation")}
                    data-testid="novosdna-observation" />
                </Field>

                {/* Consent */}
                <label className={`ndn-consent ${touched.consent && errors.consent ? "has-error" : ""}`}>
                  <input type="checkbox" checked={form.consent}
                    onChange={(e) => { upd("consent", e.target.checked); mark("consent"); }}
                    data-testid="novosdna-consent" />
                  <span>
                    Li e concordo com a <a href="#" onClick={(e) => e.preventDefault()}>Política de Privacidade</a> e autorizo o contato da escola.*
                  </span>
                </label>

                {serverError && <div className="ndn-server-error" data-testid="novosdna-error">{serverError}</div>}

                {/* Resumo da família */}
                <div className="ndn-summary" data-testid="novosdna-summary">
                  <div className="ndn-summary-title">Resumo da família</div>
                  <div className="ndn-summary-line">
                    Responsável: <strong>{form.responsible_name.trim() || "—"}</strong>
                  </div>
                  <div className="ndn-summary-line">
                    Crianças ({students.length}):
                  </div>
                  <ol className="ndn-summary-list">
                    {students.map((s, i) => (
                      <li key={s.key} data-testid={`novosdna-summary-student-${i}`}>
                        {s.name.trim() || "—"} — {s.interest_series || "série a definir"} — {s.student_period || "período a definir"}
                      </li>
                    ))}
                  </ol>
                </div>

                <button type="submit" className="ndn-submit"
                  disabled={loading || !isValid}
                  data-testid="novosdna-submit-btn">
                  {loading ? (<><span className="ndn-spinner" /> Enviando...</>) : (<><Ic.Calendar width={18} height={18} /> Enviar pré-cadastro</>)}
                </button>
              </form>
            </div>
          </section>

          {/* PROVA SOCIAL */}
          <section className="ndn-social" data-testid="novosdna-testimonials">
            <h3 className="ndn-social-title">O que as famílias dizem</h3>
            <div className="ndn-social-grid">
              {TESTIMONIALS.map((t) => (
                <figure key={t.author} className="ndn-social-card">
                  <span className="ndn-social-quote">“</span>
                  <blockquote>{t.quote}</blockquote>
                  <figcaption>
                    <strong>{t.author}</strong>
                    <span>{t.detail}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>
        </div>

        {/* ============ COLUNA DIREITA ============ */}
        <div className="ndn-col-right">
          {/* BENEFÍCIOS 3+2 */}
          <section id="proposta" className="ndn-benefits">
            <DnaPattern className="ndn-benefits-bg" />
            <h2 className="ndn-benefits-title">
              Por que as famílias escolhem o <span className="ndn-h1-accent">Novo DNA</span>?
            </h2>
            <div className="ndn-benefits-grid">
              {BENEFITS.map(({ Icon, title, desc }) => (
                <div key={title} className="ndn-benefit-card">
                  <div className="ndn-benefit-ic"><Icon width={22} height={22} /></div>
                  <div className="ndn-benefit-title">{title}</div>
                  <div className="ndn-benefit-desc">{desc}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Divider DNA */}
          <div className="ndn-dna-divider" aria-hidden>
            <DnaStrand />
          </div>

          {/* FAIXA STATS ROXA */}
          <section className="ndn-statbar">
            <DnaPattern className="ndn-statbar-bg" light />
            {STATS.map((s, i) => (
              <div key={i} className="ndn-statbar-item">
                {s.n ? (<div className="ndn-statbar-n">{s.n}</div>) : (<s.Icon width={26} height={26} />)}
                <div className="ndn-statbar-label">{s.label}</div>
              </div>
            ))}
          </section>

          {/* CONTATO */}
          <section id="contato" className="ndn-contact">
            <h3 className="ndn-contact-title">Estamos prontos para receber você!</h3>
            <p className="ndn-contact-sub">
              Nossa equipe terá prazer em tirar suas dúvidas e agendar uma visita personalizada.
            </p>
            <div className="ndn-contact-list">
              <div className="ndn-contact-row">
                <div className="ndn-contact-ic"><Ic.Phone width={20} height={20} /></div>
                <a href="tel:+5511974795016">(11) 97479-5016</a>
              </div>
              <div className="ndn-contact-row">
                <div className="ndn-contact-ic"><Ic.Mail width={20} height={20} /></div>
                <a href="mailto:financeiro@novodna.com.br">financeiro@novodna.com.br</a>
              </div>
              <div className="ndn-contact-row">
                <div className="ndn-contact-ic"><Ic.Pin width={20} height={20} /></div>
                <div>Estrada Benedito Cesario de Oliveira, 156<br />Vila Iasi</div>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* FOOTER */}
      <footer className="ndn-footer">
        <div className="ndn-footer-inner">
          <div className="ndn-footer-brand">
            <img src={LOGO} alt="Novo DNA" />
            <div>
              <div className="ndn-footer-name">NOVO DNA</div>
              <div className="ndn-footer-sub">INSTITUTO DE APRENDIZAGEM</div>
            </div>
          </div>
          <div className="ndn-footer-tag">
            Transformamos aprendizado<br />em futuro todos os dias.
          </div>
          <div className="ndn-footer-copy">
            © {new Date().getFullYear()} Novo DNA Instituto de Aprendizagem.<br />
            Todos os direitos reservados.
          </div>
          <div className="ndn-footer-social">
            <a href="https://instagram.com/novodnainstituto" target="_blank" rel="noreferrer" aria-label="Instagram"><Ic.Ig width={22} height={22} /></a>
            <a href="https://facebook.com/novodnainstituto" target="_blank" rel="noreferrer" aria-label="Facebook"><Ic.Fb width={22} height={22} /></a>
            <a href="https://youtube.com/@novodnainstituto" target="_blank" rel="noreferrer" aria-label="YouTube"><Ic.Yt width={22} height={22} /></a>
            <a href={`https://wa.me/${WHATSAPP_INSTITUCIONAL}`} target="_blank" rel="noreferrer" aria-label="WhatsApp"><Ic.Wpp width={22} height={22} /></a>
          </div>
        </div>
      </footer>

      {/* WHATSAPP FLUTUANTE (mobile-friendly) */}
      <a href={`https://wa.me/${WHATSAPP_INSTITUCIONAL}`} target="_blank" rel="noreferrer" className="ndn-fab" aria-label="Falar no WhatsApp">
        <Ic.Wpp width={26} height={26} />
      </a>
    </div>
  );
}

// ============ TELA DE SUCESSO ============
function SuccessScreen({ success, onReset }) {
  const waUrl = `https://wa.me/${WHATSAPP_INSTITUCIONAL}?text=${encodeURIComponent(`Olá! Sou ${success.first_name}, acabei de fazer o pré-cadastro no Novo DNA (protocolo ${success.protocol}) e gostaria de mais informações.`)}`;
  return (
    <div className="ndn-root ndn-success-root">
      <StyleTag />
      <div className="ndn-success-card">
        <img src={LOGO} className="ndn-success-logo" alt="Novo DNA" />
        <div className="ndn-success-heart">
          <Ic.Check width={44} height={44} />
        </div>
        <h1 className="ndn-success-title">Tudo certo, {success.first_name}!</h1>
        <p className="ndn-success-msg">
          {success.duplicated
            ? "Você já estava no nosso radar — atualizamos suas informações. Nossa equipe entrará em contato em breve para confirmar sua visita."
            : "Recebemos seu interesse em conhecer o Novo DNA. Nossa equipe entrará em contato para confirmar o melhor dia e horário para sua visita."}
        </p>
        <div className="ndn-success-proto">
          <span>Seu protocolo</span>
          <b data-testid="novosdna-protocol">{success.protocol}</b>
        </div>
        <div className="ndn-success-actions">
          <a href={waUrl} target="_blank" rel="noreferrer" className="ndn-submit ndn-btn-wa" data-testid="novosdna-success-wa">
            <Ic.Wpp width={20} height={20} /> Falar com o Novo DNA
          </a>
          <button className="ndn-nav-cta ndn-btn-alt" onClick={onReset} data-testid="novosdna-new-lead-btn">
            Novo pré-cadastro
          </button>
        </div>
      </div>
    </div>
  );
}

// ============ COMPONENTES ============
function Field({ label, error, children }) {
  return (
    <label className={`ndn-field ${error ? "has-error" : ""}`}>
      <span className="ndn-field-label">{label}</span>
      {children}
      {error && <span className="ndn-field-error">{error}</span>}
    </label>
  );
}
function YesNo({ value, onChange, testId }) {
  return (
    <div className="ndn-yesno">
      <button type="button" className={`ndn-yesno-btn ${value === true ? "is-yes" : ""}`}
        onClick={() => onChange(true)} data-testid={`${testId}-yes`}>Sim</button>
      <button type="button" className={`ndn-yesno-btn ${value === false ? "is-no" : ""}`}
        onClick={() => onChange(false)} data-testid={`${testId}-no`}>Não</button>
    </div>
  );
}

// ============ DNA HELIX (SVG puro) ============
function DnaHelix() {
  return (
    <svg className="ndn-dna" viewBox="0 0 300 400" preserveAspectRatio="xMidYMid meet" aria-hidden>
      <defs>
        <linearGradient id="ndnGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#64327D" />
          <stop offset="32%" stopColor="#c026a3" />
          <stop offset="64%" stopColor="#4fa72a" />
          <stop offset="100%" stopColor="#f06d1e" />
        </linearGradient>
      </defs>
      {/* two intertwined helix strands */}
      <g fill="none" stroke="url(#ndnGrad)" strokeWidth="8" strokeLinecap="round">
        <path d="M80 30 C 220 90, 80 170, 220 230 S 80 310, 220 370" />
        <path d="M220 30 C 80 90, 220 170, 80 230 S 220 310, 80 370" />
      </g>
      {/* rungs (base pairs) */}
      <g stroke="url(#ndnGrad)" strokeWidth="4" strokeLinecap="round" opacity="0.75">
        {Array.from({ length: 10 }, (_, i) => (
          <line key={i} x1={95 + (i % 2 ? 20 : -5)} y1={50 + i * 34} x2={205 - (i % 2 ? 20 : -5)} y2={50 + i * 34} />
        ))}
      </g>
    </svg>
  );
}

// ============ DNA PATTERN (background suave repetitivo) ============
function DnaPattern({ className, light }) {
  const uid = useId();
  return (
    <svg className={className} viewBox="0 0 400 400" preserveAspectRatio="xMidYMid slice" aria-hidden>
      <defs>
        <linearGradient id={`ndnPatG-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={light ? "#ffffff" : "#7B3F98"} stopOpacity={light ? "0.28" : "0.12"} />
          <stop offset="100%" stopColor={light ? "#ffffff" : "#16a34a"} stopOpacity={light ? "0.05" : "0.02"} />
        </linearGradient>
      </defs>
      <g fill="none" stroke={`url(#ndnPatG-${uid})`} strokeWidth="1.4" strokeLinecap="round">
        <path d="M40 20 C 120 60, 40 120, 120 160 S 40 240, 120 280 S 40 360, 120 400" />
        <path d="M120 20 C 40 60, 120 120, 40 160 S 120 240, 40 280 S 120 360, 40 400" />
        <path d="M240 20 C 320 60, 240 120, 320 160 S 240 240, 320 280 S 240 360, 320 400" />
        <path d="M320 20 C 240 60, 320 120, 240 160 S 320 240, 240 280 S 320 360, 240 400" />
      </g>
      <g stroke={`url(#ndnPatG-${uid})`} strokeWidth="0.9" opacity="0.7">
        {Array.from({ length: 20 }, (_, i) => (
          <React.Fragment key={i}>
            <line x1={55}  y1={40 + i * 19} x2={105} y2={40 + i * 19} />
            <line x1={255} y1={40 + i * 19} x2={305} y2={40 + i * 19} />
          </React.Fragment>
        ))}
      </g>
    </svg>
  );
}

// ============ DNA STRAND (divider horizontal) ============
function DnaStrand() {
  return (
    <svg viewBox="0 0 600 40" preserveAspectRatio="none" aria-hidden>
      <defs>
        <linearGradient id="ndnStrandG" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#64327D" />
          <stop offset="35%" stopColor="#c026a3" />
          <stop offset="70%" stopColor="#4fa72a" />
          <stop offset="100%" stopColor="#f06d1e" />
        </linearGradient>
      </defs>
      <g fill="none" stroke="url(#ndnStrandG)" strokeWidth="2" strokeLinecap="round">
        <path d="M0 20 C 60 4, 120 36, 180 20 S 300 4, 360 20 S 480 36, 540 20 L 600 20" />
        <path d="M0 20 C 60 36, 120 4, 180 20 S 300 36, 360 20 S 480 4, 540 20 L 600 20" />
      </g>
      <g fill="url(#ndnStrandG)">
        {Array.from({ length: 12 }, (_, i) => (
          <circle key={i} cx={50 + i * 50} cy="20" r="2.4" />
        ))}
      </g>
    </svg>
  );
}

// ============ CSS ============
function StyleTag() {
  return (<style>{`
:root {
  --ndn-purple: #64327D;
  --ndn-purple-2: #7B3F98;
  --ndn-purple-3: #3F1F5C;
  --ndn-green: #16a34a;
  --ndn-green-2: #10b981;
  --ndn-text: #1f0f3a;
  --ndn-text-2: #5c5477;
  --ndn-line: #ece5f7;
  --ndn-soft: #faf7fd;
  --ndn-lilac: #f5f0ff;
  --ndn-lilac-2: #ede4fb;
}
.ndn-root { font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif; color: var(--ndn-text); background: #fff; min-height: 100vh; -webkit-font-smoothing: antialiased; }
.ndn-root * { box-sizing: border-box; }
button, input, select, textarea { font-family: inherit; }
a { color: inherit; }

/* ========== NAV ========== */
.ndn-nav { position: sticky; top: 0; z-index: 60; background: rgba(255,255,255,0.92); backdrop-filter: saturate(140%) blur(18px); -webkit-backdrop-filter: saturate(140%) blur(18px); border-bottom: 1px solid var(--ndn-line); }
.ndn-nav-inner { max-width: 1440px; margin: 0 auto; padding: 12px 32px; display: flex; align-items: center; justify-content: space-between; gap: 20px; }
.ndn-brand { display: flex; align-items: center; gap: 10px; text-decoration: none; color: var(--ndn-text); }
.ndn-brand img { height: 44px; width: auto; display: block; }
.ndn-brand-text { line-height: 1; }
.ndn-brand-name { font-weight: 900; font-size: 20px; letter-spacing: -0.4px; color: var(--ndn-purple-3); }
.ndn-brand-sub { font-size: 8.5px; font-weight: 700; letter-spacing: 1.6px; color: var(--ndn-purple); margin-top: 2px; }
.ndn-nav-links { display: flex; gap: 28px; align-items: center; }
.ndn-nav-links a { color: var(--ndn-text); font-size: 14.5px; font-weight: 600; text-decoration: none; transition: color .18s; }
.ndn-nav-links a:hover { color: var(--ndn-purple); }
.ndn-nav-social { display: flex; align-items: center; gap: 16px; }
.ndn-nav-handle { font-size: 13.5px; font-weight: 700; color: var(--ndn-purple-3); letter-spacing: -0.1px; }
.ndn-nav-social > a { color: var(--ndn-purple-2); display: inline-flex; align-items: center; justify-content: center; transition: color .18s, transform .18s; }
.ndn-nav-social > a:hover { color: var(--ndn-purple-3); transform: translateY(-2px); }
.ndn-nav-cta { padding: 12px 22px; background: linear-gradient(135deg, var(--ndn-purple-2), var(--ndn-purple-3)); color: #fff; border: 0; border-radius: 999px; font-size: 14px; font-weight: 700; cursor: pointer; box-shadow: 0 8px 22px rgba(109,40,217,0.32); display: inline-flex; align-items: center; gap: 8px; transition: transform .18s, box-shadow .18s; }
.ndn-nav-cta:hover { transform: translateY(-1px); box-shadow: 0 12px 28px rgba(109,40,217,0.42); }

/* ========== MAIN GRID ========== */
.ndn-main { max-width: 1440px; margin: 0 auto; padding: 0 32px; display: grid; grid-template-columns: minmax(0, 1.02fr) minmax(0, 1fr); gap: 40px; }
.ndn-col-left, .ndn-col-right { min-width: 0; }

/* ========== HERO ========== */
.ndn-hero-copy { position: relative; z-index: 2; max-width: 520px; }
.ndn-h1 { font-size: clamp(32px, 3.2vw, 48px); font-weight: 900; line-height: 1.06; letter-spacing: -1.4px; color: var(--ndn-text); margin: 0; white-space: nowrap; }
.ndn-h1-accent { background: linear-gradient(90deg, #64327D 0%, #c026a3 45%, #4fa72a 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; }
.ndn-lead { font-size: 17px; color: var(--ndn-text-2); line-height: 1.55; margin: 22px 0 0; max-width: 460px; }
/* HERO layout: 2-column grid — texto com mais largura, foto direita */
.ndn-hero { position: relative; padding: 40px 0 30px; display: grid; grid-template-columns: minmax(0, 0.95fr) minmax(0, 1fr); gap: 24px; align-items: center; }
.ndn-hero-copy { position: relative; z-index: 2; }
.ndn-hero-visual { position: relative; top: auto; right: auto; width: 100%; height: 480px; z-index: 1; pointer-events: none; }
.ndn-dna { position: absolute; top: 0; left: -12%; width: 78%; height: 100%; opacity: 0.95; filter: drop-shadow(0 20px 40px rgba(109,40,217,0.22)); z-index: 1; }
.ndn-hero-photo-wrap { position: absolute; top: 34px; bottom: 34px; right: 0; left: 22%; border-radius: 50%; overflow: hidden; z-index: 2; box-shadow: 0 30px 70px rgba(76,29,149,0.28), 0 0 0 8px rgba(255,255,255,0.85); background: linear-gradient(135deg, #ede4fb, #d1fae5); }
.ndn-hero-photo { width: 100%; height: 100%; object-fit: cover; object-position: center 22%; display: block; }
.ndn-hero-tag { display: none; }
.ndn-hero-diffs { position: relative; z-index: 2; margin-top: 32px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; grid-column: 1 / -1; }

.ndn-hero-diffs { position: relative; z-index: 2; margin-top: 40px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; max-width: 620px; }
.ndn-hero-diff { display: flex; flex-direction: column; gap: 6px; }
.ndn-hero-diff-ic { width: 34px; height: 34px; border-radius: 999px; background: var(--ndn-lilac); color: var(--ndn-purple-2); display: flex; align-items: center; justify-content: center; }
.ndn-hero-diff-label { font-size: 12px; font-weight: 600; color: var(--ndn-text); line-height: 1.35; }

/* HERO média/mobile: retorna a padding + single-col */
@media (min-width: 901px) {
  .ndn-hero { padding: 40px 0 30px; }
}

/* ========== WAVE ========== */
.ndn-wave { width: 100%; height: 60px; margin-top: 20px; }
.ndn-wave svg { width: 100%; height: 100%; display: block; }

/* ========== FORM BLOCK ========== */
.ndn-form-block { display: grid; grid-template-columns: minmax(0, 0.7fr) minmax(0, 1.3fr); gap: 20px; align-items: start; padding: 8px 0 40px; }
.ndn-form-side { padding: 20px 6px 0; }
.ndn-form-side-title { font-size: 26px; font-weight: 900; letter-spacing: -0.8px; line-height: 1.15; margin: 0 0 12px; color: var(--ndn-text); }
.ndn-form-side-sub { font-size: 14px; color: var(--ndn-text-2); line-height: 1.55; margin: 0 0 20px; }
.ndn-form-bullets { list-style: none; padding: 0; margin: 0; display: grid; gap: 12px; }
.ndn-form-bullets li { display: flex; align-items: center; gap: 12px; font-size: 13.5px; font-weight: 500; color: var(--ndn-text); }
.ndn-form-bullet-ic { width: 32px; height: 32px; border-radius: 999px; background: var(--ndn-lilac); color: var(--ndn-purple-2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }

.ndn-form-card { background: #fff; padding: 28px 26px; border-radius: 20px; box-shadow: 0 20px 60px rgba(76,29,149,0.10), 0 2px 8px rgba(0,0,0,0.03); border: 1px solid var(--ndn-line); }
.ndn-form-card-badge { display: inline-block; padding: 4px 12px; background: var(--ndn-lilac); color: var(--ndn-purple-3); border-radius: 999px; font-size: 12px; font-weight: 700; margin-bottom: 14px; }
.ndn-form { display: flex; flex-direction: column; gap: 12px; }
.ndn-fgroup { font-size: 14px; font-weight: 800; color: var(--ndn-text); margin-top: 6px; }
.ndn-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.ndn-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }

.ndn-field { display: flex; flex-direction: column; gap: 5px; min-width: 0; }
.ndn-field-label { font-size: 12.5px; font-weight: 600; color: var(--ndn-text); }
.ndn-field input, .ndn-field select, .ndn-field textarea { width: 100%; padding: 10px 12px; border: 1.5px solid var(--ndn-line); border-radius: 10px; font-size: 14px; background: #fff; color: var(--ndn-text); outline: none; transition: all .18s; -webkit-appearance: none; }
.ndn-field textarea { resize: vertical; min-height: 76px; font-family: inherit; }
.ndn-field input:focus, .ndn-field select:focus, .ndn-field textarea:focus { border-color: var(--ndn-purple-2); box-shadow: 0 0 0 4px rgba(124,58,237,0.10); }
.ndn-field.has-error input, .ndn-field.has-error select, .ndn-field.has-error textarea { border-color: #ef4444; }
.ndn-field-error { font-size: 11.5px; color: #dc2626; font-weight: 500; }

.ndn-reveal { animation: ndn-reveal .28s ease-out; }
@keyframes ndn-reveal { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: none; } }

.ndn-student-card { display: flex; flex-direction: column; gap: 12px; padding: 16px; border: 1.5px solid var(--ndn-line); border-radius: 14px; background: #fcfbff; animation: ndn-reveal .28s ease-out; }
.ndn-student-head { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.ndn-student-head .ndn-fgroup { margin-top: 0; }
.ndn-removesib { background: none; border: none; padding: 4px 6px; font-size: 12px; font-weight: 700; color: #dc2626; cursor: pointer; border-radius: 8px; transition: background .15s; }
.ndn-removesib:hover { background: #fee2e2; }
.ndn-addsib-wrap { display: flex; flex-direction: column; gap: 6px; }
.ndn-addsib { align-self: flex-start; padding: 10px 16px; border-radius: 999px; border: 1.5px dashed var(--ndn-purple-2); background: var(--ndn-lilac); color: var(--ndn-purple-3); font-size: 13.5px; font-weight: 800; cursor: pointer; transition: transform .15s, background .15s; }
.ndn-addsib:hover { background: #ede9fe; transform: translateY(-1px); }
.ndn-addsib-help { margin: 0; font-size: 12px; color: var(--ndn-text-2); }
.ndn-summary { padding: 14px 16px; border-radius: 14px; background: var(--ndn-lilac); border: 1px solid var(--ndn-line); }
.ndn-summary-title { font-size: 13px; font-weight: 800; color: var(--ndn-purple-3); margin-bottom: 6px; }
.ndn-summary-line { font-size: 13px; color: var(--ndn-text); }
.ndn-summary-list { margin: 4px 0 0; padding-left: 20px; font-size: 13px; color: var(--ndn-text); display: flex; flex-direction: column; gap: 2px; }

.ndn-yesno { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.ndn-yesno-btn { padding: 10px 12px; background: #fff; border: 1.5px solid var(--ndn-line); border-radius: 10px; font-size: 14px; font-weight: 700; color: var(--ndn-text-2); cursor: pointer; transition: all .15s; }
.ndn-yesno-btn:hover { border-color: var(--ndn-purple); color: var(--ndn-purple); }
.ndn-yesno-btn.is-yes { background: var(--ndn-green); color: #fff; border-color: var(--ndn-green); }
.ndn-yesno-btn.is-no { background: #e5e7eb; color: #374151; border-color: #e5e7eb; }

.ndn-consent { display: flex; align-items: flex-start; gap: 10px; padding: 12px 14px; background: var(--ndn-soft); border-radius: 10px; border: 1.5px solid var(--ndn-line); font-size: 13px; line-height: 1.5; color: var(--ndn-text); cursor: pointer; }
.ndn-consent.has-error { border-color: #ef4444; background: #fef2f2; }
.ndn-consent input { margin-top: 2px; accent-color: var(--ndn-purple-2); width: 16px; height: 16px; }
.ndn-consent a { color: var(--ndn-purple-2); font-weight: 600; text-decoration: underline; }
.ndn-server-error { background: #fef2f2; color: #991b1b; padding: 10px 14px; border-radius: 10px; font-size: 13.5px; border: 1px solid #fecaca; }

.ndn-submit { margin-top: 6px; padding: 14px 22px; background: linear-gradient(90deg, var(--ndn-purple-2), var(--ndn-purple-3)); color: #fff; border: 0; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; box-shadow: 0 12px 28px rgba(109,40,217,0.30); display: inline-flex; align-items: center; justify-content: center; gap: 8px; transition: transform .18s, box-shadow .18s; }
.ndn-submit:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 16px 34px rgba(109,40,217,0.42); }
.ndn-submit:disabled { opacity: 0.55; cursor: not-allowed; box-shadow: none; }
.ndn-spinner { width: 16px; height: 16px; border: 2px solid #fff; border-top-color: transparent; border-radius: 999px; animation: ndn-spin .8s linear infinite; }
@keyframes ndn-spin { to { transform: rotate(360deg); } }

/* ========== PROVA SOCIAL ========== */
.ndn-social { padding: 0 0 44px; }
.ndn-social-title { font-size: 20px; font-weight: 900; letter-spacing: -0.5px; color: var(--ndn-text); margin: 0 0 16px; }
.ndn-social-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.ndn-social-card { position: relative; margin: 0; padding: 22px 18px 18px; background: var(--ndn-lilac); border: 1px solid transparent; border-radius: 16px; display: flex; flex-direction: column; transition: transform .2s, box-shadow .2s, background-color .2s; }
.ndn-social-card:hover { transform: translateY(-4px); background: #fff; border-color: var(--ndn-lilac-2); box-shadow: 0 12px 32px rgba(76,29,149,0.10); }
.ndn-social-quote { position: absolute; top: 2px; left: 14px; font-size: 42px; line-height: 1; font-weight: 900; color: var(--ndn-purple-2); opacity: 0.28; }
.ndn-social-card blockquote { margin: 0 0 14px; font-size: 13.5px; line-height: 1.55; color: var(--ndn-text); }
.ndn-social-card figcaption { margin-top: auto; display: flex; flex-direction: column; gap: 2px; }
.ndn-social-card figcaption strong { font-size: 13px; font-weight: 800; color: var(--ndn-purple-3); }
.ndn-social-card figcaption span { font-size: 11.5px; color: var(--ndn-text-2); }

/* ========== COL RIGHT ========== */
.ndn-col-right { padding: 44px 0 40px; display: flex; flex-direction: column; gap: 24px; }
.ndn-benefits { position: relative; overflow: hidden; padding: 12px 0 0; }
.ndn-benefits-bg { position: absolute; inset: 0; width: 100%; height: 100%; z-index: 0; pointer-events: none; opacity: 0.55; }
.ndn-benefits-title { position: relative; z-index: 1; font-size: clamp(24px, 2.6vw, 34px); font-weight: 900; letter-spacing: -1px; color: var(--ndn-text); margin: 0 0 24px; }
.ndn-benefits-grid { position: relative; z-index: 1; display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.ndn-benefits-grid > .ndn-benefit-card:nth-child(4),
.ndn-benefits-grid > .ndn-benefit-card:nth-child(5) { grid-column: span 1; }
.ndn-benefit-card { padding: 22px 18px; background: var(--ndn-lilac); border-radius: 16px; text-align: center; transition: all .2s; border: 1px solid transparent; position: relative; overflow: hidden; }
.ndn-benefit-card::before { content: ""; position: absolute; top: -30px; right: -30px; width: 80px; height: 80px; background: radial-gradient(circle, rgba(124,58,237,0.10), transparent 70%); border-radius: 999px; pointer-events: none; }
.ndn-benefit-card:hover { transform: translateY(-4px); background: #fff; border-color: var(--ndn-lilac-2); box-shadow: 0 12px 32px rgba(76,29,149,0.10); }
.ndn-benefit-ic { position: relative; width: 52px; height: 52px; margin: 0 auto 12px; border-radius: 999px; background: #fff; color: var(--ndn-purple-2); display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(109,40,217,0.10); }
.ndn-benefit-title { position: relative; font-size: 14.5px; font-weight: 800; color: var(--ndn-text); margin-bottom: 4px; }
.ndn-benefit-desc { position: relative; font-size: 12.5px; color: var(--ndn-text-2); line-height: 1.5; }

/* DIVIDER DNA */
.ndn-dna-divider { width: 100%; height: 40px; display: flex; align-items: center; opacity: 0.55; }
.ndn-dna-divider svg { width: 100%; height: 100%; }

/* STATBAR */
.ndn-statbar { position: relative; overflow: hidden; background: linear-gradient(135deg, var(--ndn-purple-2), var(--ndn-purple-3)); color: #fff; border-radius: 16px; padding: 24px 20px; display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; align-items: center; box-shadow: 0 18px 40px rgba(76,29,149,0.24); }
.ndn-statbar-bg { position: absolute; inset: 0; width: 100%; height: 100%; z-index: 0; pointer-events: none; opacity: 0.9; }
.ndn-statbar-item { position: relative; z-index: 1; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 6px; }
.ndn-statbar-n { font-size: 30px; font-weight: 900; letter-spacing: -1px; line-height: 1; }
.ndn-statbar-label { font-size: 11.5px; font-weight: 600; opacity: 0.95; line-height: 1.3; }

/* ========== CONTATO ========== */
.ndn-contact { background: #fff; padding: 26px 24px; border-radius: 16px; border: 1px solid var(--ndn-line); box-shadow: 0 4px 16px rgba(76,29,149,0.04); }
.ndn-contact-title { font-size: 22px; font-weight: 900; letter-spacing: -0.5px; color: var(--ndn-text); margin: 0 0 8px; }
.ndn-contact-sub { font-size: 14px; color: var(--ndn-text-2); line-height: 1.5; margin: 0 0 18px; }
.ndn-contact-list { display: grid; gap: 14px; }
.ndn-contact-row { display: flex; align-items: center; gap: 12px; font-size: 14px; color: var(--ndn-text); }
.ndn-contact-row a { color: var(--ndn-text); text-decoration: none; }
.ndn-contact-row a:hover { color: var(--ndn-purple-2); }
.ndn-contact-ic { width: 40px; height: 40px; border-radius: 999px; background: var(--ndn-lilac); color: var(--ndn-purple-2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }

/* ========== FOOTER ========== */
.ndn-footer { background: linear-gradient(135deg, #3a1078 0%, #1f0f3a 100%); color: #fff; padding: 26px 32px; margin-top: 40px; }
.ndn-footer-inner { max-width: 1440px; margin: 0 auto; display: grid; grid-template-columns: auto 1fr auto auto; gap: 32px; align-items: center; }
.ndn-footer-brand { display: flex; align-items: center; gap: 10px; }
.ndn-footer-brand img { height: 44px; filter: brightness(0) invert(1); opacity: 0.95; }
.ndn-footer-name { font-weight: 900; font-size: 18px; letter-spacing: -0.3px; }
.ndn-footer-sub { font-size: 8px; font-weight: 700; letter-spacing: 1.6px; opacity: 0.75; margin-top: 2px; }
.ndn-footer-tag { font-size: 13px; opacity: 0.85; line-height: 1.5; }
.ndn-footer-copy { font-size: 12px; opacity: 0.75; line-height: 1.5; text-align: right; }
.ndn-footer-social { display: flex; gap: 14px; }
.ndn-footer-social a { color: #fff; opacity: 0.85; transition: opacity .18s, transform .18s; display: inline-flex; }
.ndn-footer-social a:hover { opacity: 1; transform: translateY(-2px); }

/* ========== FAB ========== */
.ndn-fab { position: fixed; bottom: 20px; right: 20px; z-index: 100; width: 54px; height: 54px; border-radius: 999px; background: #25D366; color: #fff; display: flex; align-items: center; justify-content: center; box-shadow: 0 12px 28px rgba(37,211,102,0.44); transition: transform .18s; }
.ndn-fab:hover { transform: scale(1.08); }

/* ========== SUCCESS ========== */
.ndn-success-root { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #faf7fd 0%, #ecfdf5 100%); padding: 40px 22px; }
.ndn-success-card { background: #fff; max-width: 560px; width: 100%; padding: 44px 36px; border-radius: 24px; box-shadow: 0 40px 100px rgba(76,29,149,0.18); text-align: center; border: 1px solid var(--ndn-line); }
.ndn-success-logo { height: 56px; margin-bottom: 20px; }
.ndn-success-heart { width: 84px; height: 84px; margin: 0 auto 18px; border-radius: 999px; background: linear-gradient(135deg, var(--ndn-lilac), #d1fae5); color: var(--ndn-green); display: flex; align-items: center; justify-content: center; }
.ndn-success-title { font-size: clamp(26px, 3vw, 32px); font-weight: 800; margin: 0 0 12px; letter-spacing: -0.6px; color: var(--ndn-text); }
.ndn-success-msg { font-size: 15px; color: var(--ndn-text-2); line-height: 1.6; margin: 0 0 24px; }
.ndn-success-proto { display: inline-flex; flex-direction: column; align-items: center; gap: 4px; padding: 14px 26px; background: var(--ndn-lilac); border-radius: 14px; border: 1.5px dashed #c4b5fd; margin-bottom: 24px; }
.ndn-success-proto span { font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color: var(--ndn-purple-3); opacity: 0.75; }
.ndn-success-proto b { font-size: 26px; font-weight: 900; color: var(--ndn-purple-3); letter-spacing: 3px; font-family: 'SF Mono', Menlo, monospace; }
.ndn-success-actions { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }
.ndn-btn-wa { background: #25D366 !important; box-shadow: 0 12px 28px rgba(37,211,102,0.36) !important; text-decoration: none; }
.ndn-btn-alt { background: #fff !important; color: var(--ndn-purple-3) !important; border: 1.5px solid var(--ndn-lilac-2) !important; box-shadow: none !important; }

/* ========== RESPONSIVE ========== */
@media (max-width: 1180px) {
  .ndn-main { grid-template-columns: 1fr; gap: 20px; }
  .ndn-col-right { padding-top: 8px; }
  .ndn-hero-visual { width: 100%; max-width: 420px; height: 420px; margin: 0 auto; }
  .ndn-benefits-grid { grid-template-columns: repeat(3, 1fr); }
  .ndn-statbar { grid-template-columns: repeat(5, 1fr); }
}
@media (max-width: 900px) {
  .ndn-nav-inner { padding: 12px 18px; }
  .ndn-nav-links { display: none; }
  .ndn-nav-social { gap: 10px; }
  .ndn-nav-handle { display: none; }
  .ndn-brand-text { display: none; }
  .ndn-brand img { height: 40px; }
  .ndn-nav-cta { padding: 9px 14px; font-size: 12.5px; }
  .ndn-main { padding: 0 16px; }
  .ndn-hero { grid-template-columns: 1fr; padding: 26px 0; }
  .ndn-hero-visual { width: 100%; max-width: 320px; height: 320px; margin: 0 auto; }
  .ndn-h1 { font-size: 34px; }
  .ndn-lead { font-size: 15.5px; }
  .ndn-hero-diffs { grid-template-columns: repeat(2, 1fr); }
  .ndn-benefits-grid { grid-template-columns: 1fr 1fr; }
  .ndn-statbar { grid-template-columns: repeat(2, 1fr); }
  .ndn-estr { grid-template-columns: repeat(2, 1fr); }
  .ndn-form-block { grid-template-columns: 1fr; gap: 20px; }
  .ndn-form-card { padding: 22px 18px; }
  .ndn-grid-3 { grid-template-columns: 1fr; }
  .ndn-social-grid { grid-template-columns: 1fr; }
  .ndn-grid-2 { grid-template-columns: 1fr; }
  .ndn-footer-inner { grid-template-columns: 1fr; text-align: left; gap: 16px; }
  .ndn-footer-copy { text-align: left; }
}
@media (max-width: 480px) {
  .ndn-h1 { font-size: 28px; letter-spacing: -1px; }
  .ndn-benefits-grid { grid-template-columns: 1fr; }
  .ndn-statbar { grid-template-columns: 1fr 1fr; }
  .ndn-hero-diffs { grid-template-columns: 1fr; }
  .ndn-success-card { padding: 32px 20px; }
  .ndn-success-actions { flex-direction: column; }
  .ndn-success-actions > * { width: 100%; justify-content: center; }
}
`}</style>);
}
